// Formatter dùng chung giữa app.js và component React. Trước đây nằm trong
// app.js; tách ra để không phải copy sang mỗi file .tsx.
//
// Mọi hàm ngày đều ghim T12:00:00Z + timeZone UTC: site SharePoint ở timezone
// Pacific, không ghim thì ngày bị lệch 1.

export const fmtVND = (n: number): string => `${n.toLocaleString("en-US")} ₫`;

/** "2026-07-19" → "JUL 19, 2026" */
export const fmtDate = (iso: string): string =>
  new Date(`${iso}T12:00:00Z`)
    .toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" })
    .toUpperCase();

/** "2026-07" → "July 2026" */
export const monthLabel = (ym: string): string =>
  new Date(`${ym}-15T12:00:00Z`)
    .toLocaleDateString("en-US", { month: "long", year: "numeric", timeZone: "UTC" });

/** Cộng/trừ ngày trên chuỗi ISO, giữ nguyên dạng "YYYY-MM-DD". */
export function isoAddDays(iso: string, days: number): string {
  const [y, m, d] = iso.split("-").map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
}

/** 1000000 → "1M", 500000 → "500K" */
export const fmtBonusShort = (n: number): string =>
  n >= 1000000 ? `${(n / 1000000).toLocaleString("en-US")}M` : `${n / 1000}K`;
